// =======================================================
// Access text separation pour un span sur le 1er element de chaque item
// =======================================================
let htmlItemAccess = document.querySelectorAll('.access .access__text');
let i = 0;
while (i < htmlItemAccess.length) {
    let stringItem = htmlItemAccess[i].innerText.toLowerCase();
    let splitItem = stringItem.split(" ");
    let textSpan = '<span>' + splitItem.shift() + '</span>';
    let splitItemText = textSpan + splitItem;
    let textWithoutQuote = splitItemText.replace(/,/g,' ');
    htmlItemAccess[i].innerHTML = textWithoutQuote ;
    i++;
}   

// =======================================================
// Home map
// =======================================================
if(window.innerWidth > 960) {

    let map = document.querySelector('.map__svg-wrapper');
    let tooltip = document.querySelector('.map__tooltip');

    if (map) {
        map.addEventListener('mousemove', function (e) {
            let bounds = map.getBoundingClientRect();
            
            tooltip.style.top = e.clientY - bounds.top - 65 + 'px';
            tooltip.style.left = e.clientX - bounds.left - 75 + 'px'; 
        });
    }


    // Au hover sur les différentes villes (SVG)
    let citiesMap = document.querySelectorAll('.map__svg-wrapper svg a'); // on sélectionne dans le DOM toutes les villes contenues dans le SVG

    if (citiesMap) {
        citiesMap.forEach(city => { // on itère sur le tableau citiesMap
            city.addEventListener('mouseover', (event) => { // à chaque SVG de ville survolé
                tooltip.classList.add('active');
                tooltip.append(city.getAttribute('data-title'));
            });

            city.addEventListener('mouseout', (event) => { // si on ne survole plus la ville en question            
                tooltip.classList.remove('active');
                tooltip.innerHTML = "";
            });
        });
    }
}

// =======================================================
// Home select Annuaire
// =======================================================
if (document.body.classList.contains('home')) {
    const annuaireBtn = document.querySelector('.home-annuaire__btn');

    annuaireBtn.addEventListener('click', () => {
        let urlAnnuaire = document.getElementById('home-annuaire__category').value;

        if ( urlAnnuaire != '#' ) {
            window.location.href = urlAnnuaire;
        }
    });
}
